import React from 'react'
import { TLLogo } from '@components'

function TLMiddleLogo() {
  return <TLLogo color="yellow" height={22} width={22} />
}

export default TLMiddleLogo
